import axios from "axios";
import "aws-sdk/dist/aws-sdk";
import { config } from "../configs";
import { getSessionToken } from "./getToken";
import { getCustomer, getCustomerPlace } from "./customer";
import { getOrg } from "./org";

const getCurrentWorkEvents = async (orgID, isCurrent = true) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents?current=${isCurrent ? true : false}`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
      });
      let combinedData = [];
      // console.log("data", data);
      // make customer api call to get customer name for each work event
      try {
        for (let i = 0; i < data.length; i++) {
          // console.log("data[i].for_customer", data[i].for_customer);
          // get user org if the legth of for_customer is less than "819906d8-4fba-4cab-999f-2d202e4d970f" length
          let location;
          const placeId = String(data[i]?.for_place)
            ?.replace(/[{}]/g, "")
            ?.split(`"`)
            ?.filter((item) => item !== "")
            ?.filter((item) => item !== "")
            ?.filter((item) => item !== ",");
          if (placeId.length) {
            try {
              location = await getCustomerPlace(
                data[i].for_org,
                data[i].for_customer,
                placeId
              );
            } catch (e) { }
          }

          if (data[i].for_customer.length < 5) {
            const customer = await getOrg(data[i].for_org);
            combinedData.push({
              ...data[i],
              customer: customer,
              customerName: customer?.name,
              place: location && location.data ? location?.data[0].name : "",
            });
          } else {
            const customer = await getCustomer(
              data[i].for_org,
              data[i].for_customer
            );
            // console.log("customer", customer);
            combinedData.push({
              ...data[i],
              customer: customer,
              customerName: customer?.name,
              place: location && location.data ? location?.data[0].name : "",
            });
          }
        }
      } catch (error) {
        console.log("error", error);
      }
      // console.log("combinedData", combinedData);
      resolve(combinedData);

      // resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgWorkEvents = async (orgID = null) => {
  if (!orgID) {
    const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION");
    orgID = (org) ? JSON.parse(org)?.id : undefined;
  }
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const URL = `${config.baseURL}/workevents`;
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
      });
      resolve(data);

      // resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

const getOrgWorkEvent = async (orgId, id) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/workevents/${id}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const createWorkEvent = async (orgId, body) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/workevents`;
      const response = await axios.post(url, body, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const updateWorkEvent = async (orgId, workEventID, body) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/workevents/${workEventID}`;
      const response = await axios.patch(url, body, {
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
      });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
};

const publishWorkEvent = async (orgId, workEventID) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const updateURL = `${config.baseURL}/workevents/${workEventID}/publish`;
      await axios({
        method: "PUT",
        url: updateURL,
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
      });
      resolve("NOT_STARTED");
    } catch (error) {
      reject(error);
    }
  });
};

const deleteOrgWorkEvent = async (orgId, workEventID) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const url = `${config.baseURL}/workevents/${workEventID}`;
      const { data } = await axios({
        method: "DELETE",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
        url,
      });
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

// Update the work event status value.
const updateWorkEventStatus = async (orgId, workEventID, attributes) => {
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      const updateURL = `${config.baseURL}/workevents/${workEventID}/status`;
      await axios({
        method: "PUT",
        data: attributes,
        url: updateURL,
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgId,
        },
      });
      resolve(attributes);
    } catch (error) {
      reject(error);
    }
  });
};

//Client Work Events
const getCustomerWorkEvents = async (orgID = null, customerID, placeId = null) => {
  if (!orgID) {
    const org = window?.localStorage?.getItem("REDUX_CURRENT_ORGANIZATION");
    orgID = (org) ? JSON.parse(org)?.id : undefined;
  }
  return new Promise(async function (resolve, reject) {
    try {
      const jwtToken = await getSessionToken();
      let URL = `${config.baseURL}/workevents`;
      if (customerID && customerID !== "null") {
        URL += `?client=${customerID}`;
      }
      if (placeId && placeId !== "null" && placeId !== "overview") {
        URL += (URL.indexOf("?")) ? '&' : "?";
        URL += `place=${placeId}`;
      }
      const { data } = await axios({
        method: "GET",
        headers: {
          Authorization: jwtToken,
          Application: "Platform",
          Organization: orgID,
        },
        url: URL,
      });
      resolve(data);

      // resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

export {
  getOrgWorkEvents,
  getOrgWorkEvent,
  createWorkEvent,
  updateWorkEvent,
  deleteOrgWorkEvent,
  publishWorkEvent,
  updateWorkEventStatus,
  getCurrentWorkEvents,
  getCustomerWorkEvents,
};
